

import state from './moduleInvoicesState.js'
import mutations from './moduleInvoicesMutations.js'
import actions from './moduleInvoicesActions.js'
import getters from './moduleInvoicesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

